// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import xCircleIcon from "@/assets/icons/x-circle.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type XCircleIconProps = Omit<IconProps, "name">;

export function XCircleIcon(props: XCircleIconProps): React.ReactNode {
  return <Icon name={xCircleIcon} {...props} />;
}
